export interface AvatarState {
  errorState?: string;
  preview?: string;
  src?: string;
}

export const AvatarActionType = {
  SetErrorState: 0,
  SetPreview: 1,
  SetSrc: 2,
  SetPreviewAndSrc: 3,
} as const;
export type AvatarActionType = (typeof AvatarActionType)[keyof typeof AvatarActionType];

interface AvatarReducerAction {
  type: AvatarActionType;
  errorState?: string;
  preview?: string;
  src?: string;
}

export const avatarReducer = (state: AvatarState, action: AvatarReducerAction): AvatarState => {
  switch (action.type) {
    case AvatarActionType.SetErrorState:
      return {
        ...state,
        errorState: action.errorState,
      };
    case AvatarActionType.SetPreview:
      return {
        ...state,
        preview: action.preview,
      };
    case AvatarActionType.SetSrc:
      return {
        ...state,
        src: action.src,
        ...(Object.keys(action).includes('errorState') ? { errorState: action.errorState } : {}),
      };
    case AvatarActionType.SetPreviewAndSrc:
      return {
        ...state,
        preview: action.preview,
        src: action.src,
      };
    default:
      return state;
  }
};
